App.Views.TrackEquipmentMaps = {

    showFilter: function () {
        var trackFilter = new Greenmile.TrackEquipment.CreateFilter();
        trackFilter.createFilter();
    },

    clearEquipmentRoute: function (options) {

        if (Monet.Session.TrackEquipmentMaps && Monet.Session.TrackEquipmentMaps.map) {

            const layerKeys = ['TRACK_EQUIPMENT', 'EQUIPMENT', 'ARROW', 'coordDistance'];

            if (options && options.removeEvents) {
                layerKeys.push('TRACK_EVENTS', 'EVENT');
            }

            const map = Monet.Session.TrackEquipmentMaps.map;

            for (var i in map._layers) {

                if (map._layers[i].kind) {

                    var kind = map._layers[i].kind;

                    if (layerKeys.indexOf(kind) !== -1) {
                        map.removeLayer(map._layers[i]);
                    }
                }
            }

        }

    },

    fitBounds: function (coordinates) {

        var bounds = [];

        for (var i = 0; i < coordinates.length; i++) {
            var coordinate = coordinates[i].attributes;
            bounds.push(new L.LatLng(coordinate.position.latitude, coordinate.position.longitude));
        }

        Monet.Session.TrackEquipmentMaps.map.fitBounds(bounds);
    },

    getBottomPositionToMap: function () {

        var tab = document.querySelector('#TrackEquipmentMaps #tabsRouteDetail');
        var heightMap = 18;

        if (tab.offsetHeight) {
            heightMap = tab.offsetHeight;
        }

        return heightMap;

    },

    adjustHeightMap: function () {

        var map = Monet.Session.TrackEquipmentMaps.map;

        var mapContainer = document.querySelector("#TrackEquipmentMaps #trackEquipmentMapContainer");

        if (mapContainer) {
            map.invalidateSize();
        }

    },

    getDateTimeInterval: (screenSelector) => {
        if(!screenSelector) {
            throw 'Invalid Parameter!';
        }
        const initialDateFieldValue = document.querySelector(screenSelector + ' input[name="routePlay_initialDate"]') || {};
        const finalDateFieldValue = document.querySelector(screenSelector + ' input[name="routePlay_finalDate"]') || {};

        if (!initialDateFieldValue.value) {
            initialDateFieldValue.value = Monet.Format.DateTime.formatToLocale(new Date().setHours(0, 0, 0, 0));
        }

        if (!finalDateFieldValue.value) {
            finalDateFieldValue.value = Monet.Format.DateTime.getFormattedLocaleToday();
        }

        return {
            timeStart: Monet.Format.DateTime.parseLocaleToISOString(initialDateFieldValue.value),
            timeEnd: Monet.Format.DateTime.parseLocaleToISOString(finalDateFieldValue.value)
        };
    },

    setEquipementKey: (key) => {
        if(App.Forms.TrackEquipmentMaps.form) {
            App.Forms.TrackEquipmentMaps.form.fields.key.setValue(key);
        }

    }
};
